import React from 'react'
import { I18n } from '@front/volcanion/'

import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'
import { SingleOptionSelectorField, ModelMenuSelectorField } from '@front/squirtle'

const Row1 = () =>
  <Grid container spacing={1} size={12}>
    <Grid size={4}>
      <ModelMenuSelectorField
        name='job'
        label={I18n.t('order.id.alter')}
        model_name='job'
        searchMode='search'
        labelKeys={['first_step.order.order_client_id']}
        config={{
          populate: ['first_step.order']
        }}
        disabled
        required
      />
    </Grid>
    <Grid size={2}>
      <SingleOptionSelectorField
        name='important'
        labelPlacement='start'
        optionLabel={I18n.t('broadcast.important')}
        valueType='checkbox'
      />
    </Grid>
  </Grid>


const JobSection = props => <>
  <StepLabel>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant='h6'>{I18n.t('broadcast.model.job')}</Typography>
    </Box>
  </StepLabel>
  <StepContent>
    <Row1 />
  </StepContent>
</>

export default JobSection
